/*
  Elilhaam AI "Similar styles" (product page)
  Loads when the section comes near the screen:
  1. asks the visual search Worker for look-alike products close to this product's price,
  2. renders them with the theme's own product cards via the section rendering API.
*/
(function () {
  'use strict';

  function load(root) {
    if (!root || root.getAttribute('data-ai-loaded')) return;
    root.setAttribute('data-ai-loaded', '1');

    var grid = root.querySelector('[data-ai-similar-grid]');
    var limit = parseInt(root.getAttribute('data-limit'), 10) || 8;
    var url = root.getAttribute('data-endpoint') +
      '?handle=' + encodeURIComponent(root.getAttribute('data-handle')) +
      '&limit=' + limit +
      '&band=' + encodeURIComponent(root.getAttribute('data-band') || '0.4') +
      '&soldout=' + (root.getAttribute('data-soldout') === '1' ? '1' : '0');

    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.ok ? res.json() : { results: [] }; })
      .then(function (data) {
        var handles = ((data && data.results) || []).map(function (r) { return r.handle; }).filter(Boolean).slice(0, limit);
        if (!handles.length) return null;
        var renderUrl = root.getAttribute('data-render-url') + encodeURIComponent('aisimilar ' + handles.join(' '));
        return fetch(renderUrl, { credentials: 'same-origin' }).then(function (res) { return res.ok ? res.text() : ''; });
      })
      .then(function (html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var items = tmp.querySelector('.ai-similar__items');
        if (!items || !items.children.length) return;
        grid.innerHTML = '';
        while (items.firstElementChild) grid.appendChild(items.firstElementChild);
        root.hidden = false;
        document.dispatchEvent(new CustomEvent('ai-similar:loaded', { detail: { root: root } }));
      })
      .catch(function () {});
  }

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-ai-similar]');
    Array.prototype.forEach.call(roots, function (root) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              io.disconnect();
              load(root);
            }
          });
        }, { rootMargin: '800px 0px' });
        // A hidden element has no size, so observe its parent position instead.
        io.observe(root.parentElement || root);
      } else {
        load(root);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
